module.exports = __webpack_public_path__ + "img/4_81.9791d3cd.png";